// Battle Mode Data Structure - PART 1
// Extracted all villains (exercises ending with "Game") from GameMixOptions

export const BattleModeData = {
    // Villain encounters with their battle properties
    villains: {
        // ===== BAND VILLAINS =====

        // Leg Band Villains (l)
        'G87DeadLiftGame': {
            name: 'DEADLIFT DESTROYER vs YOU',
            category: 'legband',
            image: 'v1.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -6, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 8, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -8 },
                { attackValue: 9, defendValue: 0, workoutValue: 0 },
                { attackValue: -11, defendValue: 0, workoutValue: 0 },
                { attackValue: 10, defendValue: 10, workoutValue: 0 }
            ]
        },

        // Chest Band Villains (c)
        'G87DoorSmashGame': {
            name: 'DOOR SMASHER vs YOU',
            category: 'chestband',
            image: 'v2.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -4, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 6, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -5 },
                { attackValue: 7, defendValue: 0, workoutValue: 0 },
                { attackValue: -9, defendValue: 0, workoutValue: 0 },
                { attackValue: 8, defendValue: 8, workoutValue: 0 }
            ]
        },

        // Arm Band Villains (r)
        'G87OneArmPunchGame': {
            name: 'ONE ARM PUNISHER vs YOU',
            category: 'armband',
            image: 'v3.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -5, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 7, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -6 },
                { attackValue: 8, defendValue: 0, workoutValue: 0 },
                { attackValue: -10, defendValue: 0, workoutValue: 0 },
                { attackValue: 9, defendValue: 6, workoutValue: 0 }
            ]
        },

        // Shoulder Band Villains (s)
        'G87StepWideGame': {
            name: 'STEP WIDE WARRIOR vs YOU',
            category: 'shoulderband',
            image: 'v4.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -3, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 5, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -6 },
                { attackValue: 8, defendValue: 0, workoutValue: 0 },
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 6, defendValue: 9, workoutValue: 0 }
            ]
        },

        'G87OneArmOverheadPressGame': {
            name: 'ONE ARM CRUSHER vs YOU',
            category: 'shoulderband',
            image: 'v5.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -5, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 7, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -4 },
                { attackValue: 10, defendValue: 0, workoutValue: 0 },
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 9, defendValue: 7, workoutValue: 0 }
            ]
        },

        // ===== ADVANCED CHEST VILLAINS (e) =====
        'ClappingPushUpsGame': {
            name: 'CLAPPING THUNDER vs YOU',
            category: 'chest',
            image: 'v6.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 9, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -3 },
                { attackValue: 11, defendValue: 0, workoutValue: 0 },
                { attackValue: -6, defendValue: 0, workoutValue: 0 },
                { attackValue: 8, defendValue: 10, workoutValue: 0 }
            ]
        },

        'DiamondPushUpsGame': {
            name: 'DIAMOND CRUSHER vs YOU',
            category: 'chest',
            image: 'v7.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -4, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 6, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -7 },
                { attackValue: 9, defendValue: 0, workoutValue: 0 },
                { attackValue: -10, defendValue: 0, workoutValue: 0 },
                { attackValue: 7, defendValue: 8, workoutValue: 0 }
            ]
        },

        'DiveBombersGame': {
            name: 'DIVE BOMBER vs YOU',
            category: 'chest',
            image: 'v8.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 5, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -4 },
                { attackValue: 12, defendValue: 0, workoutValue: 0 },
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 10, defendValue: 6, workoutValue: 0 }
            ]
        },

        'PushUpsWideGame': {
            name: 'WIDE PUNISHER vs YOU',
            category: 'chest',
            image: 'v9.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -5, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 7, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -6 },
                { attackValue: 8, defendValue: 0, workoutValue: 0 },
                { attackValue: -9, defendValue: 0, workoutValue: 0 },
                { attackValue: 11, defendValue: 5, workoutValue: 0 }
            ]
        },

        'PancakePushUpsGame': {
            name: 'FIT BULL vs YOU',
            category: 'chest',
            image: 'v10.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                {attackValue: -6, defendValue: 0, workoutValue: 0},
                {attackValue: 0, defendValue: 8, workoutValue: 0},
                {attackValue: 0, defendValue: 0, workoutValue: -5},
                {attackValue: 10, defendValue: 0, workoutValue: 0},
                {attackValue: -8, defendValue: 0, workoutValue: 0},
                {attackValue: 9, defendValue: 7, workoutValue: 0}
            ]
        },

        'BackExtensionsGame': {
            name: 'BACK BREAKER vs YOU',
            category: 'back',
            image: 'v11.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 9, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -4 },
                { attackValue: 11, defendValue: 0, workoutValue: 0 },
                { attackValue: -6, defendValue: 0, workoutValue: 0 },
                { attackValue: 8, defendValue: 10, workoutValue: 0 }
            ]
        },

        'ChinUpsGame': {
            name: 'CHIN UP CHAMPION vs YOU',
            category: 'back',
            image: 'v12.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 6, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -7 },
                { attackValue: 12, defendValue: 0, workoutValue: 0 },
                { attackValue: -5, defendValue: 0, workoutValue: 0 },
                { attackValue: 10, defendValue: 8, workoutValue: 0 }
            ]
        },

        'AustralianPullUpsGame': {
            name: 'AUSSIE ANNIHILATOR vs YOU',
            category: 'back',
            image: 'v13.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -5, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 8, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -6 },
                { attackValue: 9, defendValue: 0, workoutValue: 0 },
                { attackValue: -10, defendValue: 0, workoutValue: 0 },
                { attackValue: 7, defendValue: 9, workoutValue: 0 }
            ]
        },

        'SeatedCableRowsGame': {
            name: 'CABLE ROW CRUSHER vs YOU',
            category: 'back',
            image: 'v14.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -6, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 7, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -5 },
                { attackValue: 10, defendValue: 0, workoutValue: 0 },
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 11, defendValue: 6, workoutValue: 0 }
            ]
        },

        'ExplosiveRowsGame': {
            name: 'EXPLOSIVE ELIMINATOR vs YOU',
            category: 'back',
            image: 'v15.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -9, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 5, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -4 },
                { attackValue: 13, defendValue: 0, workoutValue: 0 },
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 8, defendValue: 10, workoutValue: 0 }
            ]
        },

        // ===== SHOULDER VILLAINS (h) =====
        'DumbbellSquatsandPressGame': {
            name: 'SQUAT PRESS DEMON vs YOU',
            category: 'shoulder',
            image: 'v16.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -6, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 8, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -7 },
                { attackValue: 11, defendValue: 0, workoutValue: 0 },
                { attackValue: -9, defendValue: 0, workoutValue: 0 },
                { attackValue: 10, defendValue: 7, workoutValue: 0 }
            ]
        },

        'PushUpJumpsGame': {
            name: 'PUSH JUMP BEAST vs YOU',
            category: 'shoulder',
            image: 'v17.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 6, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -5 },
                { attackValue: 12, defendValue: 0, workoutValue: 0 },
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 9, defendValue: 8, workoutValue: 0 }
            ]
        },

        // ===== ARM VILLAINS (m) =====
        'ChairTricepExtensionGame': {
            name: 'TRICEP TERMINATOR vs YOU',
            category: 'arm',
            image: 'v18.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -4, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 8, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -6 },
                { attackValue: 9, defendValue: 0, workoutValue: 0 },
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 10, defendValue: 8, workoutValue: 0 }
            ]
        },

        'FrontRackStretchGame': {
            name: 'FRONT RACK RIPPER vs YOU',
            category: 'arm',
            image: 'v19.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -5, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 6, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -8 },
                { attackValue: 11, defendValue: 0, workoutValue: 0 },
                { attackValue: -9, defendValue: 0, workoutValue: 0 },
                { attackValue: 7, defendValue: 10, workoutValue: 0 }
            ]
        },

        // ===== BICEP VILLAINS (i) =====
        'BicepCurlsGame': {
            name: 'MUSCLE TWINS vs YOU',
            category: 'bicep',
            image: 'v20.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -6, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 8, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -8 },
                { attackValue: 9, defendValue: 0, workoutValue: 0 },
                { attackValue: -11, defendValue: 0, workoutValue: 0 },
                { attackValue: 10, defendValue: 10, workoutValue: 0 }
            ]
        },

        // ===== TRICEP VILLAINS (t) =====
        'DipsGame': {
            name: 'DIP DESTROYER vs YOU',
            category: 'tricep',
            image: 'v21.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 7, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -5 },
                { attackValue: 10, defendValue: 0, workoutValue: 0 },
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 9, defendValue: 9, workoutValue: 0 }
            ]
        },

        // ===== FOREARM VILLAINS (f) =====
        'FarmerSquatsGame': {
            name: 'FARMER FURY vs YOU',
            category: 'forearm',
            image: 'v22.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -5, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 7, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -6 },
                { attackValue: 8, defendValue: 0, workoutValue: 0 },
                { attackValue: -9, defendValue: 0, workoutValue: 0 },
                { attackValue: 10, defendValue: 8, workoutValue: 0 }
            ]
        },

        // ===== AB VILLAINS (a) =====
        'CrunchAndPunchGame': {
            name: 'CRUNCH PUNCHER vs YOU',
            category: 'ab',
            image: 'v23.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -6, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 8, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -5 },
                { attackValue: 10, defendValue: 0, workoutValue: 0 },
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 9, defendValue: 7, workoutValue: 0 }
            ]
        },

        'DeadBugsGame': {
            name: 'DEAD BUG SWARM vs YOU',
            category: 'ab',
            image: 'v24.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -4, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 6, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -7 },
                { attackValue: 9, defendValue: 0, workoutValue: 0 },
                { attackValue: -10, defendValue: 0, workoutValue: 0 },
                { attackValue: 8, defendValue: 9, workoutValue: 0 }
            ]
        },

        'KneeKicksGame': {
            name: 'KNEE KICK ASSASSIN vs YOU',
            category: 'ab',
            image: 'v25.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 5, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -4 },
                { attackValue: 11, defendValue: 0, workoutValue: 0 },
                { attackValue: -6, defendValue: 0, workoutValue: 0 },
                { attackValue: 10, defendValue: 8, workoutValue: 0 }
            ]
        },

        'LegRaisesGame': {
            name: 'LEG RAISE REAPER vs YOU',
            category: 'ab',
            image: 'v26.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -5, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 7, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -6 },
                { attackValue: 9, defendValue: 0, workoutValue: 0 },
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 11, defendValue: 6, workoutValue: 0 }
            ]
        },

        'SphinxPushUpsGame': {
            name: 'SPHINX SLAYER vs YOU',
            category: 'ab',
            image: 'v27.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -6, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 8, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -7 },
                { attackValue: 10, defendValue: 0, workoutValue: 0 },
                { attackValue: -9, defendValue: 0, workoutValue: 0 },
                { attackValue: 8, defendValue: 7, workoutValue: 0 }
            ]
        },

        // ===== LEG VILLAINS (g) =====
        'BoxJumpsGame': {
            name: 'BOX JUMP BEAST vs YOU',
            category: 'legs',
            image: 'v28.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 9, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -5 },
                { attackValue: 12, defendValue: 0, workoutValue: 0 },
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 10, defendValue: 8, workoutValue: 0 }
            ]
        },

        'BurpeeWithDumbbellGame': {
            name: 'BURPEE BOMBER vs YOU',
            category: 'legs',
            image: 'v29.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 6, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -4 },
                { attackValue: 13, defendValue: 0, workoutValue: 0 },
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 9, defendValue: 10, workoutValue: 0 }
            ]
        },

        'JumpingLungesGame': {
            name: 'JUMPING LUNGE DEMON vs YOU',
            category: 'legs',
            image: 'v30.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -6, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 8, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -6 },
                { attackValue: 10, defendValue: 0, workoutValue: 0 },
                { attackValue: -9, defendValue: 0, workoutValue: 0 },
                { attackValue: 11, defendValue: 7, workoutValue: 0 }
            ]
        },

        'StepUpsGame': {
            name: 'STEP UP STOMPER vs YOU',
            category: 'legs',
            image: 'v31.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -5, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 7, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -5 },
                { attackValue: 9, defendValue: 0, workoutValue: 0 },
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 10, defendValue: 8, workoutValue: 0 }
            ]
        },

        // ===== CALVES VILLAINS (v) =====
        'JumpSquatsGame': {
            name: 'JUMP SQUAT JUGGERNAUT vs YOU',
            category: 'calves',
            image: 'v32.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 6, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -4 },
                { attackValue: 11, defendValue: 0, workoutValue: 0 },
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 9, defendValue: 9, workoutValue: 0 }
            ]
        },

        'CalfRaisesGame': {
            name: 'CALF CRUSHER vs YOU',
            category: 'calves',
            image: 'v33.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -4, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 8, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -6 },
                { attackValue: 9, defendValue: 0, workoutValue: 0 },
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 10, defendValue: 7, workoutValue: 0 }
            ]
        },

        // ===== QUAD VILLAINS (q) =====
        'SumoSquatsGame': {
            name: 'SUMO SMASHER vs YOU',
            category: 'quad',
            image: 'v34.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -6, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 7, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -5 },
                { attackValue: 10, defendValue: 0, workoutValue: 0 },
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 11, defendValue: 8, workoutValue: 0 }
            ]
        },

        // ===== HAMSTRING VILLAINS (n) =====
        'DeadLiftGame': {
            name: 'DEADLIFT DESTROYER vs YOU',
            category: 'hamstring',
            image: 'v35.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 9, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -6 },
                { attackValue: 12, defendValue: 0, workoutValue: 0 },
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 10, defendValue: 9, workoutValue: 0 }
            ]
        },

        // ===== HIP VILLAINS (j) =====
        'ClamshellExerciseGame': {
            name: 'CLAMSHELL CRUSHER vs YOU',
            category: 'hip',
            image: 'v36.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -5, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 6, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -7 },
                { attackValue: 8, defendValue: 0, workoutValue: 0 },
                { attackValue: -9, defendValue: 0, workoutValue: 0 },
                { attackValue: 10, defendValue: 8, workoutValue: 0 }
            ]
        },

        'SprawlsGame': {
            name: 'SPRAWL SPIDER vs YOU',
            category: 'overall',
            image: 'v38.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 7, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -5 },
                { attackValue: 12, defendValue: 0, workoutValue: 0 },
                { attackValue: -9, defendValue: 0, workoutValue: 0 },
                { attackValue: 11, defendValue: 9, workoutValue: 0 }
            ]
        },

        // ===== GYM CHEST VILLAINS ($) =====
        'BenchPressGame': {
            name: 'BENCH PRESS BEAST vs YOU',
            category: 'chestgym',
            image: 'v39.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -10, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 12, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -8 },
                { attackValue: 15, defendValue: 0, workoutValue: 0 },
                { attackValue: -12, defendValue: 0, workoutValue: 0 },
                { attackValue: 13, defendValue: 12, workoutValue: 0 }
            ]
        },

        'DumbbellFlyesGame': {
            name: 'DUMBBELL FLY FURY vs YOU',
            category: 'chestgym',
            image: 'v40.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 10, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -6 },
                { attackValue: 12, defendValue: 0, workoutValue: 0 },
                { attackValue: -9, defendValue: 0, workoutValue: 0 },
                { attackValue: 11, defendValue: 10, workoutValue: 0 }
            ]
        },

        'CableCrossoversGame': {
            name: 'CABLE CROSSOVER CRUSHER vs YOU',
            category: 'chestgym',
            image: 'v41.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 9, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -5 },
                { attackValue: 11, defendValue: 0, workoutValue: 0 },
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 10, defendValue: 9, workoutValue: 0 }
            ]
        },

        'ChestPressMachineGame': {
            name: 'CHEST PRESS PUNISHER vs YOU',
            category: 'chestgym',
            image: 'v42.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -9, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 8, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -7 },
                { attackValue: 13, defendValue: 0, workoutValue: 0 },
                { attackValue: -10, defendValue: 0, workoutValue: 0 },
                { attackValue: 12, defendValue: 8, workoutValue: 0 }
            ]
        },

        // ===== GYM BACK VILLAINS (x) =====
        'BentOverRowsGame': {
            name: 'BENT ROW BRUISER vs YOU',
            category: 'backgym',
            image: 'v43.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 10, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -6 },
                { attackValue: 12, defendValue: 0, workoutValue: 0 },
                { attackValue: -9, defendValue: 0, workoutValue: 0 },
                { attackValue: 11, defendValue: 10, workoutValue: 0 }
            ]
        },

        'LatPulldownsGame': {
            name: 'LAT PULLDOWN LIQUIDATOR vs YOU',
            category: 'backgym',
            image: 'v44.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -9, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 7, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -5 },
                { attackValue: 13, defendValue: 0, workoutValue: 0 },
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 12, defendValue: 9, workoutValue: 0 }
            ]
        },

        'DeadliftsGame': {
            name: 'DEADLIFT DEATH DEALER vs YOU',
            category: 'backgym',
            image: 'v45.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -11, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 12, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -8 },
                { attackValue: 15, defendValue: 0, workoutValue: 0 },
                { attackValue: -10, defendValue: 0, workoutValue: 0 },
                { attackValue: 14, defendValue: 12, workoutValue: 0 }
            ]
        },

        // ===== GYM SHOULDER VILLAINS (&) =====
        'ArnoldPressGame': {
            name: 'ARNOLD ANNIHILATOR vs YOU',
            category: 'shouldergym',
            image: 'v46.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 9, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -6 },
                { attackValue: 11, defendValue: 0, workoutValue: 0 },
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 10, defendValue: 9, workoutValue: 0 }
            ]
        },

        'LateralRaisesGame': {
            name: 'LATERAL RAISE LIQUIDATOR vs YOU',
            category: 'shouldergym',
            image: 'v47.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -6, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 8, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -5 },
                { attackValue: 10, defendValue: 0, workoutValue: 0 },
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 9, defendValue: 8, workoutValue: 0 }
            ]
        },

        'ShrugsGame': {
            name: 'SHRUG SLAMMER vs YOU',
            category: 'shouldergym',
            image: 'v48.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -5, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 7, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -4 },
                { attackValue: 9, defendValue: 0, workoutValue: 0 },
                { attackValue: -6, defendValue: 0, workoutValue: 0 },
                { attackValue: 8, defendValue: 7, workoutValue: 0 }
            ]
        },

        'SkullCrushersGame': {
            name: 'SKULL CRUSHER vs YOU',
            category: 'tricepgym',
            image: 'v50.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 9, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -6 },
                { attackValue: 12, defendValue: 0, workoutValue: 0 },
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 10, defendValue: 9, workoutValue: 0 }
            ]
        },

        // ===== GYM AB VILLAINS (+) =====
        'PlankVariationsGame': {
            name: 'PLANK PUNISHER vs YOU',
            category: 'abgym',
            image: 'v51.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -6, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 8, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -5 },
                { attackValue: 10, defendValue: 0, workoutValue: 0 },
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 9, defendValue: 8, workoutValue: 0 }
            ]
        },

        'CableCrunchesGame': {
            name: 'CABLE CRUNCH CRUSHER vs YOU',
            category: 'abgym',
            image: 'v52.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 9, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -4 },
                { attackValue: 11, defendValue: 0, workoutValue: 0 },
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 10, defendValue: 9, workoutValue: 0 }
            ]
        },

        // ===== GYM LEG VILLAINS (=) =====
        'SquatsGame': {
            name: 'SQUAT SLAYER vs YOU',
            category: 'leggym',
            image: 'v53.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -9, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 10, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -7 },
                { attackValue: 12, defendValue: 0, workoutValue: 0 },
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 11, defendValue: 10, workoutValue: 0 }
            ]
        },

        'LegPressGame': {
            name: 'LEG PRESS PULVERIZER vs YOU',
            category: 'leggym',
            image: 'v54.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 9, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -6 },
                { attackValue: 11, defendValue: 0, workoutValue: 0 },
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 10, defendValue: 9, workoutValue: 0 }
            ]
        },

        'LegCurlsGame': {
            name: 'LEG CURL LIQUIDATOR vs YOU',
            category: 'leggym',
            image: 'v55.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -6, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 8, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -5 },
                { attackValue: 10, defendValue: 0, workoutValue: 0 },
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 9, defendValue: 8, workoutValue: 0 }
            ]
        },

        // ===== GYM OVERALL VILLAINS (>) =====
        'MilitaryPressGame': {
            name: 'MILITARY PRESS MANGLER vs YOU',
            category: 'overallgym',
            image: 'v56.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -10, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 11, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -8 },
                { attackValue: 13, defendValue: 0, workoutValue: 0 },
                { attackValue: -9, defendValue: 0, workoutValue: 0 },
                { attackValue: 12, defendValue: 11, workoutValue: 0 }
            ]
        },

        // ===== SPECIAL BODY WEIGHT VILLAINS =====
        // Core Body Weight Villains (d)
        'MountainClimbersGame': {
            name: 'MOUNTAIN CLIMBER MADMAN vs YOU',
            category: 'corebody',
            image: 'v57.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -5, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 7, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -6 },
                { attackValue: 9, defendValue: 0, workoutValue: 0 },
                { attackValue: -8, defendValue: 0, workoutValue: 0 },
                { attackValue: 10, defendValue: 7, workoutValue: 0 }
            ]
        },

        'ScorpionStretchGame': {
            name: 'SCORPION STINGER vs YOU',
            category: 'corebody',
            image: 'v58.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -6, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 6, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -5 },
                { attackValue: 8, defendValue: 0, workoutValue: 0 },
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 9, defendValue: 8, workoutValue: 0 }
            ]
        },



        // Shoulder Body Weight Villains (_)
        'PikePushUpsGame': {
            name: 'PIKE PUSH ELIMINATOR vs YOU',
            category: 'shoulderbody',
            image: 'v60.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: -6, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: 7, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: -4 },
                { attackValue: 9, defendValue: 0, workoutValue: 0 },
                { attackValue: -7, defendValue: 0, workoutValue: 0 },
                { attackValue: 8, defendValue: 8, workoutValue: 0 }
            ]
        },

        // ===== THE ULTIMATE VILLAIN =====
        'AirSquatsGame': {
            name: 'COLDPUNCH TOM vs YOU',
            category: 'legbody',
            image: 'v47.jpg',
            moveOptions: ['Pushups', 'Walking Lunges', 'Knee Ups', 'Dips', 'Burpee', 'Pull Ups'],
            weights: [
                { attackValue: 1, defendValue: 0, workoutValue: 0 },
                { attackValue: 0, defendValue: -1, workoutValue: 0 },
                { attackValue: 0, defendValue: 0, workoutValue: 1 },
                { attackValue: -2, defendValue: 0, workoutValue: 0 },
                { attackValue: 4, defendValue: 0, workoutValue: 0 },
                { attackValue: -3, defendValue: -3, workoutValue: 0 }
            ]
        }
    },

    // ===== COMPLETE BATTLE SYSTEM FUNCTIONS =====

    // Battle action functions (randomized effects)
    battleActions: [
        // Damage function
        (reps, attackValue, defendValue) => {
            const damage = reps * 2;
            attackValue.value -= damage;
            return `Lost ${damage} attack points!`;
        },
        // Defense function
        (reps, attackValue, defendValue) => {
            const defense = reps * 1;
            defendValue.value += defense;
            return `Gained ${defense} defense points!`;
        },
        // Workout boost function
        (reps, attackValue, workoutValue) => {
            const boost = Math.floor(reps * 1.5);
            workoutValue.value += boost;
            return `Earned ${boost} workout points!`;
        }
    ],

    // Hidden Health Bonus calculation
    calculateHiddenHealthBonus: (savedWorkouts) => {
        let totalPastReps = 0;

        savedWorkouts.forEach(workout => {
            if (workout.totalReps) {
                totalPastReps += workout.totalReps;
            }
        });

        // 1 bonus point per 10 past reps, capped at 100
        return Math.min(Math.floor(totalPastReps / 10), 100);
    },

    // Check if exercise is a villain
    isVillain: (exerciseName) => {
        return exerciseName.includes('Game');
    },

    // Get villain data by name
    getVillainData: (villainName) => {
        return BattleModeData.villains[villainName] || null;
    },

    // Get random villain from category
    getRandomVillainFromCategory: (category) => {
        const categoryVillains = Object.entries(BattleModeData.villains)
            .filter(([name, data]) => data.category === category)
            .map(([name]) => name);

        if (categoryVillains.length === 0) return null;

        const randomIndex = Math.floor(Math.random() * categoryVillains.length);
        return categoryVillains[randomIndex];
    },

    // Get all villain names
    getAllVillainNames: () => {
        return Object.keys(BattleModeData.villains);
    },

    // Get villain count by category
    getVillainCountByCategory: () => {
        const counts = {};
        Object.values(BattleModeData.villains).forEach(villain => {
            counts[villain.category] = (counts[villain.category] || 0) + 1;
        });
        return counts;
    }
};

// Export muscle group mappings for battle mode
export const battleMuscleGroups = {
    "l": "legband", "c": "chestband", "b": "backband", "o": "coreband",
    "r": "armband", "s": "shoulderband", "e": "chest", "k": "back",
    "h": "shoulder", "m": "arm", "i": "bicep", "t": "tricep",
    "f": "forearm", "g": "legs", "a": "abs", "v": "calves",
    "p": "trap", "q": "quad", "n": "hamstring", "u": "glute",
    "j": "hip", "y": "thigh", "z": "oblique", "!": "overall",
    "$": "chestgym", "x": "backgym", "&": "shouldergym", "*": "armgym",
    "(": "bicepgym", ")": "tricepgym", "-": "forearmgym", "+": "abgym",
    "=": "leggym", "[": "quadgym", "]": "hamgym", "{": "glutegym",
    "}": "calvegym", ":": "trapgym", ";": "obliquegym", "|": "hipgym",
    "<": "thighgym", ">": "overallgym", "~": "legbody", "w": "chestbody",
    "@": "backbody", "d": "corebody", "^": "armbody", "_": "shoulderbody"
};

export default BattleModeData;